const fb = require('./firebaseConfig.js')
const querystring = require('querystring')
const axios = require('axios')

const base = fb.base

var cache = window.localStorage

exports.get = function (endpoint, params, success) {
  // every api call must be authenticated against a user with a valid IdToken
  // firebase will autorefresh idToken if expired and has a valid user logged in
  fb.auth.currentUser.getIdToken(true).then(function (idToken) {
    // params.user = fb.session.user.uid
    let query = querystring.stringify(params)
    if (query.length > 0) {
      endpoint += `?${query}`
    }

    if ( params.cache && cache.hasOwnProperty(endpoint)) {
      console.log('using cache', endpoint)
      success(JSON.parse(cache.getItem(endpoint)))
    } else {
      console.log(`%capiFunction%c /${endpoint}`, 'background:green;color:white', 'color:black')
      let url = `${base}/${endpoint}`
      axios.get(url)
        .then((res) => {
          // console.log(res)
          success(res.data)
          if (params.cache) {
            cache.setItem(endpoint, JSON.stringify(res.data))
          }
        })
        .catch((error) => {
          console.error(error)
          if ( error.response && error.response.status === 401) {
            fb.auth.signOut()
          }          
        })
    }
  }).catch(function (error) {
    console.error(error)
  })
}

exports.post = function (endpoint, data, success) {
  // every api call must be authenticated against a user
  // data.user = fb.session.user
  // console.log(data)
  let url = `${base}/${endpoint}`
  axios.post(url, data)
    .then((res) => {
      success(res)
    })
    .catch((error) => {
      console.error('error for ' + data)
      console.error(error)
    })
}

exports.students = {
  get: (params, success) => {
    exports.get('dbStudents', params, success)
  },
  save: (params, success) => {
    exports.post('dbStudents', params, success)
  },
  invoice: (student, success) => {
    exports.post('invoice', student, success)
  },
  activate: (student, success) => {
    exports.post('dbStudentActivate', student, success)
  },
  deactivate: (student, success) => {
    exports.post('dbStudentDeactivate', student, success)
  },
  gmailInfo: (username, success) => {
    exports.get('gsuiteAccountInfo', { username: username }, success)
  }
}

exports.accounts = {
  get: (params, success) => {
    exports.get('dbStudents', params, success)
  },
  save: (params, success) => {
    exports.post('dbStudents', params, success)
  },
  invoice: (student, success) => {
    exports.post('invoice', student, success)
  },
  activate: (student, success) => {
    exports.post('dbStudentActivate', student, success)
  },
  deactivate: (student, success) => {
    exports.post('dbStudentDeactivate', student, success)
  },
  gmailInfo: (username, success) => {
    exports.get('gsuiteAccountInfo', { username: username }, success)
  }
}


exports.audit = {
  get: (params, success) => {
    exports.get('dbActivityLog', params, success)
  }
}

exports.inventory = {
  get: (params, success) => {
    exports.get('dbInventory', params, success)
  },
  parseActions: (items, success) => {
    exports.post('dbParseInventoryActions', items, success)
  },
  assign: (action, success) => {
    exports.post('dbAssignItem', action, success)
  },
  getReport: (success) => {
    exports.get('openItemByTeacher', {}, success)
  },
  update: (item, success) => {
    exports.post('dbUpdateCirculation', item, success)
  }
}

exports.assets = {
  get: (params, success) => {
    exports.get('dbAssets', params, success)
  }
}

exports.asset = {
  get: (uid, success) => {
    exports.get('dbAsset', { uid: uid }, success)
  },
  save: (asset, success) => {
    exports.post('dbAsset', asset, success)
  },
  delete: (asset, success) => {
    asset.delete = true
    exports.post('dbAsset', asset, success)
  },
  lastUsedItem: (uid, success) => {
    exports.get('dbLastUsedItem', { asset_uid: uid }, success)
  }
}

exports.assetCodes = {
  recache: (success) => {
    exports.get('dbAssetCodes', { cache: false }, success)
  },
  get: (success) => {
    exports.get('dbAssetCodes', { cache: true }, success)
  },
  save: (assetCode, success) => {
    exports.post('dbAssetCodes', { assetCode: assetCode }, success)
  }
}

exports.assetCategories = {
  recache: (success) => {
    exports.get('dbAssetCategories', { cache: false }, success)
  },
  get: (success) => {
    exports.get('dbAssetCategories', { cache: true }, success)
  },
  save: (category, success) => {
    exports.post('dbAssetCategories', { category: category }, success)
  }
}

exports.locations = {
  get: (success) => {
    exports.get('dbLocations', { cache: true }, success)
  },
  save: (location, success) => {
    exports.post('dbLocations', { location: location }, success)
  },
  delete: (location, success) => {
    location.delete = true
    exports.post('dbLocations', { location: location }, success)
  }
}

exports.classes = {
  get: (params, success) => {
    exports.get('getClassrooms', params, success)
  }
}

exports.users = {
  get: (success) => {
    exports.get('users', { cache: false }, success)
  }
}

exports.user = {
  getProfile: (success) => {
    exports.get('user', {}, success)
  },
  update: (user, success) => {
    exports.post('updateUserRole', { editUser: user }, success)
  },
  create: (user, success) => {
    exports.post('user', { newUser: user }, success)
  }
}
